import { Suspense } from "react";
import { OpenAiAdsPageViewTracker } from "./page-view-tracker";

/**
 * Fires a page_viewed OpenAI Ads conversion on mount and on every client-side navigation.
 * Render once, high in the tree (e.g. the root layout), for automatic page-view tracking.
 * Wrapped in Suspense since `usePathname` opts the tracker into dynamic rendering.
 */
export const OpenAiAdsPageView = () => (
  <Suspense fallback={null}>
    <OpenAiAdsPageViewTracker />
  </Suspense>
);
